'use strict';
import adModal from './ad-aggregation.model.html';

const angular = require('angular');

const uiRouter = require('angular-ui-router');
import routes from './ad-aggregation.routes';

export class AdAggregationComponent {

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;
    }

    $onInit() {
        this.totalCount = 0;
        this.$http.get('/api/ad-aggregations')
            .then(response => {
                if(response.data.data) {
                    this.adDefaults = response.data.data;
                    this.totalCount = response.data.data.length;
                }
            });
    }

    createOne() {
        const that = this;
        this.$uibModal.open({
            template: adModal,
            size: 'lg',
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance, FileUploader) {
                $scope.vm = {};
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };

                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post('/api/ad-aggregations', $scope.vm).then(response => {
                            that.$onInit();
                            $uibModalInstance.close();
                        }, error => {
                            console.log(error);
                        });
                    }
                };

                $scope.uploadAndGetUrl = function() {
                    that.$uibModal.open({
                        template: fu,
                        size: 'lg',
                        /*@ngInject*/
                        controller($scope, $http, $uibModalInstance, FileUploader) {
                            $scope.vm = {};
                            $scope.isUpping = false;
                            $scope.isUppingError = false;
                            const uploader = $scope.imageUploader = new FileUploader({
                                url: '/api/share_imgs/9528/',
                                method: 'POST',
                                autoUpload: true,
                            });
                            uploader.onSuccessItem = function(fileItem, response, status, headers) {
                                if(status === 200) {
                                    $scope.isUpping = false;
                                    $scope.vm.url = response.data.small_img;
                                }
                            };
                            uploader.filters.push({
                                name: 'Filter',
                                fn(item, options) {
                                    if(item.type.indexOf('image') !== -1) {
                                        $scope.isUpping = true;
                                        $scope.isUppingError = false;
                                        return true;
                                    } else {
                                        $scope.isUppingError = true;
                                        return false;
                                    }
                                }
                            });
                            $scope.cancel = function() {
                                $uibModalInstance.close();
                            };
                        }
                    });
                };
            }
        });
    }

    delete(ad) {
        this.$http.delete(`/api/ad-aggregations/${ad._id}`)
            .then(response => {
                this.$onInit();
            });
    }

    edit(ad) {
        const that = this;
        this.$uibModal.open({
            template: adModal,
            size: 'lg',
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance, FileUploader) {
                $scope.vm = ad;
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };

                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post('/api/ad-aggregations', $scope.vm).then(response => {
                            that.$onInit();
                            $uibModalInstance.close();
                        }, error => {
                            console.log(error);
                        });
                    }
                };
            }
        });
    }
}

export default angular.module('tttApp.ad-aggregation', [uiRouter])
    .config(routes)
    .component('adAggregation', {
        template: require('./ad-aggregation.html'),
        controller: AdAggregationComponent,
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/ad-aggregation/ad-aggregation.component.js